<template>
  <v-navigation-drawer :permanent="$vuetify.display.lgAndUp" width="350">
    <v-list open-strategy="single">
      <template v-for="menu in menus" :key="menu.active">
        <v-list-item
          v-if="
            (menu.to || menu.href) &&
            !menu.subItems &&
            (menu.check_permission_condition === true
              ? check_permission(menu.check_permission)
              : menu.check_permission_condition === false
              ? !check_permission(menu.check_permission)
              : true)
          "
          :to="menu.to"
          :href="menu.href"
          :target="menu.target"
          :prepend-icon="menu.icon"
          :title="$t(menu.label)"
          link
        >
          <template v-slot:append v-if="menu.noti_badge">
            <v-badge dot color="error" content=""></v-badge>
          </template>
        </v-list-item>

        <v-list-group
          v-if="
            menu.subItems &&
            (menu.check_permission_condition === true
              ? check_permission(menu.check_permission)
              : menu.check_permission_condition === false
              ? !check_permission(menu.check_permission)
              : true)
          "
          :value="menu.active"
        >
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              :prepend-icon="menu.icon"
              :title="$t(menu.label)"
            ></v-list-item>
          </template>
          <template v-for="(sub, i) in menu.subItems" :key="i">
            <v-list-item
              v-if="
                sub.check_permission_condition === true
                  ? check_permission(sub.check_permission)
                  : sub.check_permission_condition === false
                  ? !check_permission(sub.check_permission)
                  : true
              "
              :prepend-icon="sub.icon"
              :title="$t(sub.label)"
              :to="sub.to"
              :href="sub.href"
              :target="sub.target"
              link
              @click="handleSubItemClick(sub)"
            >
              <template v-slot:append v-if="sub.noti_badge">
                <v-badge dot color="error" content=""></v-badge>
              </template>
            </v-list-item>
          </template>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// import DrawerItem from "./DrawerItem";
import { check_permission } from "@/router/acl";

export default {
  components: {
    // DrawerItem,
  },

  data: () => ({
    menus: [
      {
        active: 0,
        href: "",
        target: "_self",
        label: "drawer.main_menu",
        icon: "mdi-microsoft-xbox-controller-menu",
        check_permission: ["main_menu"],
        check_permission_condition: true,
      },
      {
        active: 1,
        to: "",
        label: "drawer.matriculation_system",
        icon: "mdi-book-account",
        check_permission: null,
        check_permission_condition: null,
        subItems: [
          {
            href: "https://www.reg.kmitl.ac.th/storage/kmitl1/manual/student.pdf",
            target: "_blank",
            label: "drawer.manual",
            icon: "mdi-book-open-variant",
            check_permission: null,
            check_permission_condition: null,
          },
          {
            to: "login",
            label: "app_bar.login",
            icon: "mdi-login",
            check_permission: ["authen"],
            check_permission_condition: false,
            action: "login",
          },
          {
            to: "/",
            label: "app_bar.homepage",
            icon: "mdi-home",
            check_permission: null,
            check_permission_condition: null,
          },
          {
            to: "info_undergraduate",
            label: "app_bar.info",
            icon: "mdi-information-box",
            check_permission: ["info_undergraduate"],
            check_permission_condition: true,
          },
          {
            to: "list_undergraduate",
            label: "app_bar.list",
            icon: "mdi-list-box",
            check_permission: ["list_undergraduate"],
            check_permission_condition: true,
          },
          {
            to: "info_graduate",
            label: "app_bar.info_graduate",
            icon: "mdi-information-box",
            check_permission: ["info_graduate"],
            check_permission_condition: true,
          },
          {
            to: "list_graduate",
            label: "app_bar.list_graduate",
            icon: "mdi-list-box",
            check_permission: ["list_graduate"],
            check_permission_condition: true,
          },
          {
            to: "main",
            label: "app_bar.main",
            icon: "mdi-book-account-outline",
            check_permission: ["main"],
            check_permission_condition: true,
            noti_badge: false, // will be set dynamically in mounted()
          },
          {
            to: "questionnaire",
            label: "app_bar.questionnaire",
            icon: "mdi-comment-text-outline",
            check_permission: ["questionnaire"],
            check_permission_condition: true,
          },
          {
            to: "",
            label: "app_bar.logout",
            icon: "mdi-logout",
            check_permission: ["authen"],
            check_permission_condition: true,
            action: "logout",
          },
        ],
      },
      {
        active: 2,
        to: "",
        label: "drawer.personnel_record",
        icon: "mdi-card-account-details",
        check_permission: ["kmitl1"],
        check_permission_condition: true,
        subItems: [
          {
            to: "kmitl1",
            label: "kmitl1.title",
            icon: "mdi-card-account-details-outline",
            check_permission: ["kmitl1"],
            check_permission_condition: true,
          },
        ],
      },
      {
        active: 3,
        to: "",
        label: "drawer.officer",
        icon: "mdi-account-multiple-check",
        check_permission: ["main_officer"],
        check_permission_condition: true,
        subItems: [
          {
            href: "https://www.reg.kmitl.ac.th/storage/kmitl1/manual/officer.pdf",
            target: "_blank",
            label: "drawer.manual",
            icon: "mdi-book-open-variant",
            check_permission: ["main_officer"],
            check_permission_condition: true,
          },
          {
            to: "list_undergraduate",
            label: "officer.check",
            icon: "mdi-account-check",
            check_permission: ["main_officer"],
            check_permission_condition: true,
          },
          {
            to: "list_graduate",
            label: "officer.check_grad",
            icon: "mdi-account-check",
            check_permission: ["main_officer"],
            check_permission_condition: true,
          },
          {
            to: "main_officer",
            label: "officer.main_officer",
            icon: "mdi-account-supervisor",
            check_permission: ["main_officer"],
            check_permission_condition: true,
          },
          {
            to: "kmitl1",
            label: "officer.kmitl1",
            icon: "mdi-card-account-details-outline",
            check_permission: ["kmitl1"],
            check_permission_condition: true,
          },
        ],
      },
      {
        active: 4,
        to: "",
        label: "drawer.user_management",
        icon: "mdi-account-cog",
        check_permission: ["generate_studentID", "import_data", "export_data"],
        check_permission_condition: true,
        subItems: [
          {
            to: "find_edit",
            label: "officer.find_edit_data",
            icon: "mdi-magnify",
            check_permission: ["find_edit"],
            check_permission_condition: true,
          },
          {
            to: "generate_studentID",
            label: "generate.title",
            icon: "mdi-numeric",
            check_permission: ["generate_studentID"],
            check_permission_condition: true,
          },
          {
            to: "import_data",
            label: "insert.title",
            icon: "mdi-account-arrow-left",
            check_permission: ["import_data"],
            check_permission_condition: true,
          },
          {
            to: "export_data",
            label: "export.title",
            icon: "mdi-account-arrow-right",
            check_permission: ["export_data"],
            check_permission_condition: true,
          },
        ],
      },
      {
        active: 5,
        to: "",
        label: "drawer.config",
        icon: "mdi-cog",
        check_permission: ["config_document", "config_round", "config_year"],
        check_permission_condition: true,
        subItems: [
          {
            to: "config_document",
            label: "config_document.config_document",
            icon: "mdi-cog-outline",
            check_permission: ["config_document"],
            check_permission_condition: true,
          },
          {
            to: "config_round",
            label: "config_round.config_round",
            icon: "mdi-cog-outline",
            check_permission: ["config_round"],
            check_permission_condition: true,
          },
          {
            to: "config_year",
            label: "config_year.config_year",
            icon: "mdi-cog-outline",
            check_permission: ["config_year"],
          },
        ],
      },
    ],
  }),

  computed: {
    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },

    is_completed() {
      if (!this.surrogated_student_info) return null;
      if (
        this.surrogated_student_info &&
        this.surrogated_student_info.MATRICULATION_STATUS_ID == "3"
      )
        return true;
      else return false;
    },
  },

  watch: {
    is_completed() {
      // Dynamically set noti_badge for matriculation subItem after fetching
      const matriculationMenus = this.menus.find(
        (item) => item.label === "drawer.matriculation_system"
      );
      if (matriculationMenus && matriculationMenus.subItems) {
        const mainSubItem = matriculationMenus.subItems.find(
          (sub) => sub.to === "main"
        );
        if (mainSubItem) {
          mainSubItem.noti_badge = this.is_completed == false;
        }
      }
    },
  },

  methods: {
    check_permission,

    handleSubItemClick(item) {
      if (item.action === "login") {
        // this.login();
      } else if (item.action === "logout") {
        this.logout();
      }
    },

    login() {
      this.$store.dispatch("keycloak/login");
    },
    logout() {
      this.$store.dispatch("user/logout");
    },
  },

  mounted() {
    const mainMenu = this.menus.find(
      (item) => item.label === "drawer.main_menu"
    );
    mainMenu.href =
      process.env.VUE_APP_ENV !== "production"
        ? "https://regis-dev.reg.kmitl.ac.th/#/main_menu"
        : "https://regis.reg.kmitl.ac.th/#/main_menu";
  },
};
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  background-color: rgba(0, 0, 0, 0.7) !important;
  backdrop-filter: blur(5px);
  color: #fff;
}

.v-list {
  padding: 10px;
}

/* สำหรับ item ที่ไม่อยู่ใน group */
.v-list > .v-list-item {
  margin-bottom: 10px;
}

.v-list-group {
  border: 1px solid #888888;
  border-radius: 10px;
  margin-bottom: 10px;
}

.v-list-group__items > .v-list-item {
  padding-inline-start: 32px !important;
}

:deep(.v-list-item__prepend > .v-badge ~ .v-list-item__spacer),
:deep(.v-list-item__prepend > .v-icon ~ .v-list-item__spacer),
:deep(.v-list-item__prepend > .v-tooltip ~ .v-list-item__spacer) {
  width: 16px;
}

.v-list-group--open {
  border: 1px solid #e35205;
}

.v-list > .v-list-group > .v-list-group__header.v-list-item--active {
  background-color: #e35205;
  border-radius: 7px 7px 0 0 !important;
}

.v-list > .v-list-item.v-list-item--active,
.v-list > .v-list-group > .v-list-group__items > .v-list-item--active {
  color: #e35205;
}

:deep(.v-list-item--active .v-list-item__overlay),
:deep(.list_sub_menu.v-list-item--active .v-list-item__overlay) {
  color: rgba(0, 0, 0, 0.5) !important;
  border-radius: 7px;
}
</style>
